import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

const SheetPrintView = props => {
  const [state, setState] = useState({
    id: 0,
    formData: {},
    activeTab: 1,
    memberid: 0,
    success_msg: false,
    JobCard_SheetSizing: [],
  });

  const formTitle = "Sheet Sizing";
  const breadCrumbTitle = "Sheet Sizing";
  const breadCrumbItem = "Print " + formTitle;

  const insidePapersHindi = {
    "Media Paper 100": "मीडिया पेपर 100",
    "Media Paper 150": "मीडिया पेपर 150",
    "Media Ply 100": "मीडिया प्लाय 100",
    "Media Ply Hard 150": "मीडिया प्लाय हार्ड 150",
    "Soft Paper": "सॉफ्ट पेपर",
    "Virgin Paper 220": "वर्जिन पेपर 220",
    "Virgin Paper 28+": "वर्जिन पेपर 28+",
    "Virgin Ply 150": "वर्जिन प्लाय 150",
    "Virgin Ply Hard 220": "वर्जिन प्लाय हार्ड 220",
    "Virgin Ply Hard 28+": "वर्जिन प्लाय हार्ड 28+",
  };

  const outsidePapersHindi = {
    "Media Paper 100": "मीडिया पेपर 100",
    "Media Paper 150": "मीडिया पेपर 150",
    "Media Ply 100": "मीडिया प्लाय 100",
    "Media Ply Hard 150": "मीडिया प्लाय हार्ड 150",
    "Soft Paper": "सॉफ्ट पेपर",
    "Virgin Paper 220": "वर्जिन पेपर 220",
    "Virgin Paper 28+": "वर्जिन पेपर 28+",
    "Virgin Ply 150": "वर्जिन प्लाय 150",
    "Virgin Ply Hard 220": "वर्जिन प्लाय हार्ड 220",
    "Virgin Ply Hard 28+": "वर्जिन प्लाय हार्ड 28+",
  };

  useEffect(() => {
    const sheetSizingData = JSON.parse(
      sessionStorage.getItem("SheetSizingData")
    );
    console.log(sheetSizingData);
    if (sheetSizingData) {
      setState(prevState => ({
        ...prevState,
        JobCard_SheetSizing: sheetSizingData.JobCard_SheetSizing,
        SheetSizingData: sheetSizingData.SheetSizingData,
      }));
    }
  }, []);

  const convertPaperToHindi = (value, translationMap) => {
    if (!value) return "";
    return value
      .split(",")
      .map(v => translationMap[v.trim()] || v.trim())
      .join(", ");
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <React.Fragment>
      <style>
        {`
          @media print {
            .print-button {
              display: none !important;
            }
          }
        `}
      </style>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={breadCrumbTitle}
            breadcrumbItem={breadCrumbItem}
          />

          {/* Print Button */}
          <Row className="mb-3">
            <Col>
              <Button
                color="primary"
                onClick={handlePrint}
                className="print-button"
                style={{
                  float: "right",
                  marginBottom: "20px",
                }}
              >
                <i className="fas fa-print me-2"></i>
                Print
              </Button>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg="8" md="10" sm="12">
              <Card>
                <CardBody>
                  <div className="page-content">
                    {state.SheetSizingData &&
                      state.SheetSizingData.map((row, index) => (
                        <div
                          key={index}
                          style={{
                            padding: "15px",
                            fontFamily: "serif",
                            width: "13.5cm",
                            height: "17.2cm",
                            margin: "0 auto",
                            backgroundColor: "white",
                            marginTop: index === 0 ? "0" : "20px",
                            marginBottom: "20px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            pageBreakAfter: "always",
                            pageBreakInside: "avoid",
                            overflow: "hidden",
                          }}
                        >
                          {/* Header */}
                         
                          
                          {/* 4.1 cm length div */}
                          <div
                            style={{
                              height: "4.1cm",
                              
                            }}
                          >
                            <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: 10,
                             
                              marginTop: "70px",
                            }}
                          >
                            <div style={{ marginLeft: "100px" }}>
                             {row.VoucherNo}
                            </div>
                            <div style={{ marginRight: "100px" }}>
                               {row.VoucherDate}
                            </div>
                          </div>


                              <div style={{ fontWeight: "bold", fontSize: "12px",  marginLeft: "170px"   }}>
                               {row.Ledger} 
                              <br/>
                                {row.CodeNo}
                                <br/>
                            
                                {"CA/2025-26/" + row.OrderNo}
                              
                            </div>
                            </div>
                           
                            
                          

                          {/* Main Size */}
                          <div style={{height: "5cm"}}>
                          <div
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                              fontSize: "12px",
                              margin: "20px 0 10px 0",
                            }}
                          >
                            {row.Length1} {row.LengthMar} x {row.Width1}{" "}
                            {row.WidthMar} x {row.Height1} {row.HeightMar} (
                            {row.UnitSizeName}) ({row.PlyName}) {row.NoOfBox}{" "}
                            Box {row.CalculationType} {row.TypeName}
                          </div>

                          {/* Calculation Columns */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              margin: "20px 0",
                              gap: "40px",
                              position: "relative",
                            }}
                          >
                            {/* Length Calculation */}
                            <div>
                              <div
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  fontSize: "14px",
                                }}
                              >
                                Length Calculation
                              </div>
                              <div
                                style={{
                                  textAlign: "center",
                                  fontSize: "13px",
                                }}
                              >
                                <span>
                                  {row.Length} {row.LengthMar}
                                </span>
                                <br />
                                <span>
                                  {row.Width} {row.WidthMar}
                                </span>
                                <br />
                                <span>
                                  {row.Pinning} {row.PinningMargin}
                                </span>
                                <br />
                                -----
                                <br />
                                <span>{row.LengthX}</span>
                                <br />
                                -----
                                <br />
                              </div>
                            </div>

                            {/* First Vertical Divider - between Length and Height */}
                            <div
                              style={{
                                position: "absolute",
                                left: "40%",
                                top: "0",
                                bottom: "0",
                                width: "1px",
                                backgroundColor: "#000",
                                transform: "translateX(-50%)",
                              }}
                            ></div>

                            {/* Height Calculation */}
                            <div>
                              <div
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  fontSize: "14px",
                                }}
                              >
                                Height Calculation
                              </div>
                              <div
                                style={{
                                  textAlign: "center",
                                  fontSize: "13px",
                                }}
                              >
                                <span>
                                  {row.Height} {row.HeightMar}
                                </span>
                                <br />
                                <span>
                                  {row.Width} {row.WidthMar}
                                </span>
                                <br />
                                <span>
                                  {row.Height} {row.HeightMar}
                                </span>
                                <br />
                                -----
                                <br />
                                <span>{row.HeightX}</span>
                                <br />
                                -----
                                <br />
                              </div>
                            </div>

                            {/* Second Vertical Divider - between Height and Total */}
                            <div
                              style={{
                                position: "absolute",
                                left: "60%",
                                top: "0",
                                bottom: "0",
                                width: "1px",
                                backgroundColor: "#000",
                                transform: "translateX(-50%)",
                              }}
                            ></div>

                            {/* Total Calculation */}
                            <div>
                              <div
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  fontSize: "14px",
                                }}
                              >
                                Total
                              </div>
                              <div
                                style={{
                                  textAlign: "center",
                                  fontSize: "13px",
                                }}
                              >
                             <span>{row.HeightX}</span>    x{" "}
                             <span>{row.LengthX}</span>   = {row.ShortQty} Sheets
                              </div>
                            </div>
                          </div>
                          </div>

                          <div
                                style={{
                                  textAlign: "center",
                                  fontSize: "13px",
                                }}
                              >
                               <span>{row.HeightX}</span>   x{" "}
                               <span>{row.LengthX}</span>
                              </div>

                          <div
                            style={{
                              textAlign: "center",
                              margin: "20px 0 0 0",
                              fontSize: "13px",
                            }}
                          >
                           
                             
                            <div>
                               
                              {convertPaperToHindi(
                                row.OutsidePapers,
                                outsidePapersHindi
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default compose(container)(SheetPrintView);
